export default __webpack_public_path__ + "static/mask_c-7b6b0bc8bdf9d98845bb5775f4c77d5d.png";